import { useResetAtom } from 'jotai/utils'
import React from 'react'

import { useInvalidateSurveyForSettingsQuery } from '~/hooks/useSurveyForSettingsQuery'

import { dialogInfoAtom } from '../atoms'

export const useCloseDialogWithRefresh = () => {
  const resetDialogInfo = useResetAtom(dialogInfoAtom)

  const invalidateSurveyForSettingsQuery = useInvalidateSurveyForSettingsQuery()

  return React.useCallback(() => {
    invalidateSurveyForSettingsQuery()
    resetDialogInfo()
  }, [invalidateSurveyForSettingsQuery, resetDialogInfo])
}
